<div class="prompt-container">
    <h1 mat-dialog-title>{{data.title}}</h1>
    <p>{{data.text}}</p>
    <div mat-dialog-actions>
        <button mat-button class="light" (click)="onNoClick()">Close</button>
        <button mat-flat-button color="warn" [mat-dialog-close]="true">Ok</button>
    </div>
</div>